export class UserOrderOverview {
    
    public maxAvailableAmount: number;
    public amountRemaining: number;
    public actualPurchasedAmount: number;
    public minDateToCheck: Date;
    public nbOrderTotal: number;
    public nbOrderNotApproved: number;
    public nbOrderCompleted: number;
    public nbOrderInCartMode: number;
    public qtyConsumedByProductId: object;
    public productComponentDeductedFromBudget: number;
    public shippingFeesDeductedFromBudget: number;

    constructor( 
        maxAvailableAmount: number | null,
        amountRemaining: number | null,
        actualPurchasedAmount: number,
        minDateToCheck: Date,
        nbOrderTotal: number,
        nbOrderNotApproved: number,
        nbOrderCompleted: number,
        nbOrderInCartMode: number,
        qtyConsumedByProductId: object,
        productComponentDeductedFromBudget: number = 0,
        shippingFeesDeductedFromBudget: number = 0
    )   
    {
        this.maxAvailableAmount = maxAvailableAmount ? maxAvailableAmount : 0;
        this.amountRemaining = amountRemaining ? amountRemaining : 0;
        this.actualPurchasedAmount = actualPurchasedAmount;
        this.minDateToCheck = minDateToCheck;
        this.nbOrderTotal = nbOrderTotal;
        this.nbOrderNotApproved = nbOrderNotApproved;
        this.nbOrderCompleted = nbOrderCompleted;
        this.nbOrderInCartMode = nbOrderInCartMode;
        this.qtyConsumedByProductId = qtyConsumedByProductId;
        this.productComponentDeductedFromBudget = productComponentDeductedFromBudget;
        this.shippingFeesDeductedFromBudget = shippingFeesDeductedFromBudget;
    }
 
}